// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pintura-sticker-editor{--editor-modal-overlay-opacity:0.65;--editor-modal-border-radius:1.5rem;--editor-max-width:48%;--editor-max-height:50%}", ""]);
// Exports
module.exports = exports;
